import React from 'react'

export const ProspectosPrestadores = () => {
  return (
    <div>ProspectosPrestadores</div>
  )
}
